import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import NavigationStack from './NavigationStack';
import './styles';
import Activities from './pages/Activities';
import BuildingProcess from './pages/BuildingProcess';
import Index from './pages/IndexPage';
import Conservation from './pages/Conservation';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import Overview from './pages/Overview';
import Homes from './pages/Homes';
import HomeDetail from './pages/HomeDetail';
import Blogposts from './pages/Blogposts';
import BlogpostDetail from './pages/BlogpostDetail';
import NoRoute from './pages/NoRoute';
import OurArchitect from './pages/OurArchitect';
import ContactUs from './pages/ContactUs';
import ContactUsThankYou from './pages/ContactUs/ThankYou';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import ResidentLogin from './pages/ResidentLogin';
import PasswordReset from './pages/Account/PasswordReset';
import PortAransas from './pages/PortAransas';
import Vision from './pages/Vision';
import Investment from './pages/Investment';
import ApprovedBuilders from './pages/ApprovedBuilders';
import Directions from './pages/Directions';
import OverallSitePlan from './pages/OverallSitePlan';
import PhaseOneSitePlan from './pages/PhaseOneSitePlan';


ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack={NavigationStack}
      components={[
        { override: 'Index', component: Index },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunitiesList', component: Communities },
        { override: 'HomesList', component: Homes },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'BlogpostList', component: Blogposts },
        { override: 'BlogpostDetail', component: BlogpostDetail },
        { override: 'NoRoute', component: NoRoute },
      ]}
      routes={[
        { name: 'approved-builders', exact: true, path: '/preferred-builders', component: ApprovedBuilders },
        { name: 'activities', exact: true, path: '/activities', component: Activities },
        { name: 'building-process', exact: true, path: '/building-process', component: BuildingProcess },
        { name: 'conservation', exact: true, path: '/conservation', component: Conservation },
        { name: 'overview', exact: true, path: '/overview', component: Overview },
        { name: 'contact-us', exact: true, path: '/contact-us', component: ContactUs },
        { name: 'contact-us-thank-you', exact: true, path: '/contact-us/thank-you', component: ContactUsThankYou, sitemapIgnore: true },
        { name: 'history', exact: true, path: '/history', component: History },
        { name: 'privacy-policy', exact: true, path: '/privacy-policy', component: PrivacyPolicy },
        { name: 'terms', exact: true, path: '/terms', component: Terms },
        { name: 'resident-login', exact: true, path: '/resident-login', component: ResidentLogin },
        { name: 'password-reset', exact: true, path: '/resident-login/password-reset', component: PasswordReset },
        { name: 'port-aransas', exact: true, path: '/port-aransas-calendar', component: PortAransas },
        { name: 'vision', exact: true, path: '/vision', component: Vision },
        { name: 'our-architect', exact: true, path: '/our-architects', component: OurArchitect },
        { name: 'investment', exact: true, path: '/investment', component: Investment },
        { name: 'directions', exact: true, path: '/directions', component: Directions },
        { name: 'overall-site-plan', exact: true, path: '/master-plan', component: OverallSitePlan },
        { name: 'phase-one-site-plan', exact: true, path: '/phase-one-site-plan', component: PhaseOneSitePlan },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js